module.exports = __webpack_public_path__ + "img/audio-portrait_cn.58d0821.jpg";